import React from 'react';
import NewProducts from '../../../../../widgets/NewProducts';
// import NewBrands from '~view/widgets/NewBrands';
import UpdatedBrands from '~view/widgets/UpdatedBrands';

const CategoryCampaigns: React.FC<{ category: string }> = ({ category }) => {
  return (
    <div>
      <NewProducts category={category} />
      {/* <NewBrands category={category} /> */}
      <UpdatedBrands category={category} />
    </div>
  );
};

export default CategoryCampaigns;
